import { getCnpjGestor, getEmailLogin } from '@/services';

export function getRelatoriosHeaders() {
  return {
    Email_Login: getEmailLogin(),
  };
}

export function hasGestorSelecionado() {
  const cnpjGestor = getCnpjGestor();
  return Boolean(cnpjGestor && cnpjGestor !== '00000000000000');
}
